<template>
  <div>
    <el-tabs
    type="border-card"
    v-model="activeName"
    >
      <el-tab-pane
      label="查询"
      name="one"
      >
        <!-- 查询表单 -->
        <el-form
        ref="search_form"
        :model="search_form"
        label-width="80px"
        class="search_form"
        >
          <el-divider content-position="left">基础信息</el-divider>
          <el-form-item class="form_other" label="报表类型" prop="functionType">
            <el-select
            style="width: 100%;"
            :popper-append-to-body="false"
            v-model="search_form.functionType"
            placeholder="请选择"
            clearable
            @change="change_functionType"
            >
              <el-option
              v-for="item in functionType_list"
              :key="item.value"
              :label="item.name"
              :value="item.value"
              :disabled="item.disabled"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="form_other" label="报表名称" prop="functionName">
            <el-select
            ref="function_name"
            style="width: 100%;"
            :popper-append-to-body="false"
            v-model="search_form.functionName"
            placeholder="请选择"
            clearable
            @change="get_fields"
            >
              <el-option
              v-for="item in functionName_list"
              :key="item.value"
              :label="item.text"
              :value="item.value"
              :disabled="item.disabled"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-divider content-position="left">条件1:</el-divider>
          <el-form-item label="关系" prop="relationOne">
            <el-select
            style="width: 100%;"
            :popper-append-to-body="false"
            v-model="search_form.relationOne"
            >
              <el-option label="where" value=""></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="字段" prop="fieldOne">
            <el-select
            style="width: 100%;"
            :popper-append-to-body="false"
            v-model="search_form.fieldOne"
            placeholder="请选择"
            clearable
            >
              <el-option
              v-for="item in field_list"
              :key="item"
              :label="item"
              :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="条件" prop="conditionOne">
            <el-select
            style="width: 100%;"
            :popper-append-to-body="false"
            v-model="search_form.conditionOne"
            placeholder="请选择"
            clearable
            >
              <el-option
              v-for="item in condition_list"
              :key="item.value"
              :label="item.name"
              :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="值" prop="conditionValue">
            <el-input v-model="search_form.conditionValue"></el-input>
          </el-form-item>
          <el-form-item label="后缀" prop="suffixOne">
            <el-select
            style="width: 100%;"
            :popper-append-to-body="false"
            v-model="search_form.suffixOne"
            placeholder="请选择"
            clearable
            >
              <el-option label=")" value=")"></el-option>
            </el-select>
          </el-form-item>
          <el-divider content-position="left">条件2:</el-divider>
          <el-form-item label="关系" prop="relationTwo">
            <el-select
            style="width: 100%;"
            :popper-append-to-body="false"
            v-model="search_form.relationTwo"
            placeholder="请选择"
            clearable
            >
              <el-option
              v-for="item in relation_list"
              :key="item.value"
              :label="item.name"
              :value="item.value"
              :disabled="item.disabled"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="字段" prop="fieldTwo">
            <el-select
            style="width: 100%;"
            :popper-append-to-body="false"
            v-model="search_form.fieldTwo"
            placeholder="请选择"
            clearable
            >
              <el-option
              v-for="item in field_list"
              :key="item"
              :label="item"
              :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="条件" prop="conditionTwo">
            <el-select
            style="width: 100%;"
            :popper-append-to-body="false"
            v-model="search_form.conditionTwo"
            placeholder="请选择"
            clearable
            >
              <el-option
              v-for="item in condition_list"
              :key="item.value"
              :label="item.name"
              :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="值" prop="conditionValueTwo">
            <el-input v-model="search_form.conditionValueTwo"></el-input>
          </el-form-item>
          <el-form-item label="后缀" prop="suffixTwo">
            <el-select
            style="width: 100%;"
            :popper-append-to-body="false"
            v-model="search_form.suffixTwo"
            placeholder="请选择"
            clearable
            >
              <el-option label=")" value=")"></el-option>
            </el-select>
          </el-form-item>
          <el-divider content-position="left">条件3:</el-divider>
          <el-form-item label="关系" prop="relationThree">
            <el-select
            style="width: 100%;"
            :popper-append-to-body="false"
            v-model="search_form.relationThree"
            placeholder="请选择"
            clearable
            >
              <el-option
              v-for="item in relation_list"
              :key="item.value"
              :label="item.name"
              :value="item.value"
              :disabled="item.disabled"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="字段" prop="fieldThree">
            <el-select
            style="width: 100%;"
            :popper-append-to-body="false"
            v-model="search_form.fieldThree"
            placeholder="请选择"
            clearable
            >
              <el-option
              v-for="item in field_list"
              :key="item"
              :label="item"
              :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="条件" prop="conditionThree">
            <el-select
            style="width: 100%;"
            :popper-append-to-body="false"
            v-model="search_form.conditionThree"
            placeholder="请选择"
            clearable
            >
              <el-option
              v-for="item in condition_list"
              :key="item.value"
              :label="item.name"
              :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="值" prop="conditionValueThree">
            <el-input v-model="search_form.conditionValueThree"></el-input>
          </el-form-item>
          <el-form-item label="后缀" prop="suffixThree">
            <el-select
            style="width: 100%;"
            :popper-append-to-body="false"
            v-model="search_form.suffixThree"
            placeholder="请选择"
            clearable
            >
              <el-option label=")" value=")"></el-option>
            </el-select>
          </el-form-item>
          <el-divider content-position="left">条件4:</el-divider>
          <el-form-item label="关系" prop="relationFour">
            <el-select
            style="width: 100%;"
            :popper-append-to-body="false"
            v-model="search_form.relationFour"
            placeholder="请选择"
            clearable
            >
              <el-option
              v-for="item in relation_list"
              :key="item.value"
              :label="item.name"
              :value="item.value"
              :disabled="item.disabled"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="字段" prop="fieldFour">
            <el-select
            style="width: 100%;"
            :popper-append-to-body="false"
            v-model="search_form.fieldFour"
            placeholder="请选择"
            clearable
            >
              <el-option
              v-for="item in field_list"
              :key="item"
              :label="item"
              :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="条件" prop="conditionFour">
            <el-select
            style="width: 100%;"
            :popper-append-to-body="false"
            v-model="search_form.conditionFour"
            placeholder="请选择"
            clearable
            >
              <el-option
              v-for="item in condition_list"
              :key="item.value"
              :label="item.name"
              :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="值" prop="conditionValueFour">
            <el-input v-model="search_form.conditionValueFour"></el-input>
          </el-form-item>
          <el-form-item label="后缀" prop="suffixFour">
            <el-select
            style="width: 100%;"
            :popper-append-to-body="false"
            v-model="search_form.suffixFour"
            placeholder="请选择"
            clearable
            >
              <el-option label=")" value=")"></el-option>
            </el-select>
          </el-form-item>
          <el-divider content-position="left">条件5:</el-divider>
          <el-form-item label="关系" prop="relationFive">
            <el-select
            style="width: 100%;"
            :popper-append-to-body="false"
            v-model="search_form.relationFive"
            placeholder="请选择"
            clearable
            >
              <el-option
              v-for="item in relation_list"
              :key="item.value"
              :label="item.name"
              :value="item.value"
              :disabled="item.disabled"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="字段" prop="fieldFive">
            <el-select
            style="width: 100%;"
            :popper-append-to-body="false"
            v-model="search_form.fieldFive"
            placeholder="请选择"
            clearable
            >
              <el-option
              v-for="item in field_list"
              :key="item"
              :label="item"
              :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="条件" prop="conditionFive">
            <el-select
            style="width: 100%;"
            :popper-append-to-body="false"
            v-model="search_form.conditionFive"
            placeholder="请选择"
            clearable
            >
              <el-option
              v-for="item in condition_list"
              :key="item.value"
              :label="item.name"
              :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="值" prop="conditionValueFive">
            <el-input v-model="search_form.conditionValueFive"></el-input>
          </el-form-item>
          <el-form-item label="后缀" prop="suffixFive">
            <el-select
            style="width: 100%;"
            :popper-append-to-body="false"
            v-model="search_form.suffixFive"
            placeholder="请选择"
            clearable
            >
              <el-option label=")" value=")"></el-option>
            </el-select>
          </el-form-item>
          <el-divider content-position="left">显示字段</el-divider>
          <el-form-item class="form_other1">
            <el-checkbox-group
            v-model="new_field_list"
            >
              <el-checkbox
              v-for="item in show_field_list"
              :label="item"
              :key="item"
              >{{item}}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item class="form_other1">
            <el-button
            type="primary"
            icon="el-icon-search"
            @click="search_query"
            v-if="btn_permission.includes('middle:customFunction:dataList')||btn_permission.includes('superAdmin')"
            >查询</el-button>
            <el-button
            icon="el-icon-close"
            @click="reset_query"
            v-if="btn_permission.includes('middle:customFunction:dataList')||btn_permission.includes('superAdmin')"
            >重置</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane
      label="列表"
      name="two"
      >
        <!-- 查询列表 -->
        <el-table
        v-loading="list_loading"
        :data="list_data"
        highlight-current-row
        border
        max-height="400"
        >
          <el-table-column
          v-for="item in new_field_list"
          :key="item"
          align="center"
          :prop="item"
          :label="item"
          ></el-table-column>
        </el-table>
        <!-- 查询列表分页 -->
        <el-pagination
        style="margin: 10px auto;"
        background
        @size-change="query_size_change"
        @current-change="query_current_change"
        :current-page="query_current_page"
        :page-sizes="[100,500,1000,2000]"
        :page-size="query_page_size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="query_total"
        ></el-pagination>
        <el-button
        type="primary"
        icon="el-icon-download"
        @click="doExport"
        v-if="btn_permission.includes('middle:customFunction:canExport')||btn_permission.includes('superAdmin')"
        >导出Excel</el-button>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  export default {
    data() {
      return{
        btn_permission:JSON.parse(localStorage.getItem(localStorage.getItem('userName')+'permission')),
        activeName:'one',
        //报表类型下拉框
        functionType_list:[],
        //报表名称下拉框
        functionName_list:[],
        //字段下拉框
        field_list:[],
        //关系下拉框
        relation_list:[
          {
            value:'AND',
            name:'AND'
          },
          {
            value:'OR',
            name:'OR'
          },
          {
            value:'AND(',
            name:'AND('
          },
          {
            value:'OR(',
            name:'OR('
          },
          {
            value:')AND',
            name:')AND'
          },
          {
            value:')OR',
            name:')OR'
          }
        ],
        //条件下拉框
        condition_list:[
          {
            value:'>',
            name:'>'
          },
          {
            value:'<',
            name:'<'
          },
          {
            value:'=',
            name:'='
          },
          {
            value:'>=',
            name:'>='
          },
          {
            value:'<=',
            name:'<='
          },
          {
            value:' like ',
            name:'like'
          },
          {
            value:' not like ',
            name:'not like'
          },
          {
            value:'in(',
            name:'in('
          },
          {
            value:'not in(',
            name:'not in('
          }
        ],
        //显示字段复选框列表
        queryWapper:'',
        showFields:'',
        dataSourceType:'',
        new_field_list:[],
        show_field_list:[],
        //查询表单
        search_form:{
          functionType:'',
          functionName:'',
          relationOne:'',
          fieldOne:'',
          conditionOne:'',
          conditionValue:'',
          suffixOne:'',
          relationTwo:'',
          fieldTwo:'',
          conditionTwo:'',
          conditionValueTwo:'',
          suffixTwo:'',
          relationThree:'',
          fieldThree:'',
          conditionThree:'',
          conditionValueThree:'',
          suffixThree:'',
          relationFour:'',
          fieldFour:'',
          conditionFour:'',
          conditionValueFour:'',
          suffixFour:'',
          relationFive:'',
          fieldFive:'',
          conditionFive:'',
          conditionValueFive:'',
          suffixFive:''
        },
        //查询列表
        list_data:[],
        //列表懒加载
        list_loading:false,
        //查询列表分页
        query_current_page:1,
        query_page_size:10,
        query_total:0
      }
    },
    created() {
      let that=this
      that.publicAjax.axios_set()
      //报表类型下拉框
      that.$axios({
        method:'get',
        url:that.publicAjax.extra_path+'/admin/dict/select/byCode/customFunctionType'
      }).then(data=>{
        if(data.data.success==true){
          that.functionType_list=data.data.data
        }
      })
    },
    mounted() {

    },
    methods:{
      //查询条件拼接函数
      connectSql(relation, fields, condition, sqlValue, suffix) {
          let fieldPrefix = "";
          let fieldSuffix = "";
          if (this.dataSourceType === 'MYSQL') {
              fieldPrefix = "`";
              fieldSuffix = "`";
          } else if (this.dataSourceType === "SQLSERVER") {
              fieldPrefix = "[";
              fieldSuffix = "]";
          }
          let sql = relation + fieldPrefix + fields + fieldSuffix + condition;
          console.info(sql);
          if (condition === ' like ' || condition === ' not like ') {
              sql += "'%" + sqlValue + "%'" + suffix;
          } else {
              sql += "'" + sqlValue + "'" + suffix;
          }
          console.info(sql);
          return sql;
      },
      checkSql(relation, condition, fields, sqlValue) {
          //第一个存放是否有查询条件，第二个存放是否校验通过
          let val = [];
          //存在一个查询条件非空
          if (relation !== '' || condition !== '' || fields !== '' || sqlValue !== '') {
              val.push(true, relation !== '' && condition !== '' && fields !== '' && sqlValue !== '');
              return val;
          }
          val.push(false, true);
          return val;
      },
      //报表类型change事件
      change_functionType(val){
        let that=this
        that.search_form.functionName=''
        that.search_form.relationOne=''
        that.search_form.fieldOne=''
        that.search_form.conditionOne=''
        that.search_form.conditionValue=''
        that.search_form.suffixOne=''
        that.search_form.relationTwo=''
        that.search_form.fieldTwo=''
        that.search_form.conditionTwo=''
        that.search_form.conditionValueTwo=''
        that.search_form.suffixTwo=''
        that.search_form.relationThree=''
        that.search_form.fieldThree=''
        that.search_form.conditionThree=''
        that.search_form.conditionValueThree=''
        that.search_form.suffixThree=''
        that.search_form.relationFour=''
        that.search_form.fieldFour=''
        that.search_form.conditionFour=''
        that.search_form.conditionValueFour=''
        that.search_form.suffixFour=''
        that.search_form.relationFive=''
        that.search_form.fieldFive=''
        that.search_form.conditionFive=''
        that.search_form.conditionValueFive=''
        that.search_form.suffixFive=''
        //报表名称下拉框
        that.$axios({
          method:'get',
          url:that.publicAjax.extra_path+'/middle/custom_function/function_name/'+val
        }).then(data=>{
          if(data.data.success==true){
            that.functionName_list=data.data.data
          }else{
            that.$message.warning(data.data.message)
          }
        })
      },
      //报表名称change事件，获取显示字段
      get_fields(val){
        if(!val){
          return false
        }
        let that=this
        that.$axios({
          method:'get',
          url:that.publicAjax.extra_path+'/middle/custom_function/fields/'+val
        }).then(data=>{
          if(data.data.success==true){
            that.dataSourceType=data.data.data.dataSourceType
            that.field_list=data.data.data.fields
            that.show_field_list=data.data.data.fields
            that.new_field_list=data.data.data.fields
          }
        })
      },
      //获取查询列表
      get_query(){
        let that=this
        that.list_loading=true
        that.$axios({
          method:'get',
          url:that.publicAjax.extra_path+'/middle/custom_function/functionData/'
          +that.search_form.functionName+'?queryWrapper='+encodeURI(that.queryWapper)
          +'&page='+that.query_current_page+'&limit='+that.query_page_size
          +'&showFields='+that.showFields+'&functionType='+that.search_form.functionType
        }).then(data=>{
          that.list_loading=false
          if(data.data.success==true){
            that.list_data=data.data.data.list
            that.query_total=data.data.data.total
          }else{
            that.$message.warning(data.data.message)
          }
        })
      },
      //查询表单
      search_query(){
        if(this.search_form.functionName==''){
          this.$message.warning('请选择报表类型和报表名')
          return false
        }

        //拼接查询条件(1-5)
        this.queryWapper=''
        if(this.search_form.fieldOne!=''||this.search_form.conditionOne!=''||this.search_form.conditionValue!=''){
          if(this.search_form.fieldOne!=''&&this.search_form.conditionOne!=''&&this.search_form.conditionValue!=''){
            this.queryWapper += this.connectSql(this.search_form.relationOne, this.search_form.fieldOne, this.search_form.conditionOne, this.search_form.conditionValue, this.search_form.suffixOne)
          }else{
            this.$message.warning('条件1存在不完整查询！请填写完整')
            return false
          }
        }
        let checkTwo=this.checkSql(this.search_form.relationTwo,this.search_form.fieldTwo,this.search_form.conditionTwo,this.search_form.conditionValueTwo)
        if(checkTwo[0]){
          if(checkTwo[1]){
            this.queryWapper+=this.connectSql(this.search_form.relationTwo,this.search_form.fieldTwo,this.search_form.conditionTwo,this.search_form.conditionValueTwo,this.search_form.suffixTwo)
          }else{
            this.$message.warning('条件2存在不完整查询！请填写完整')
            return false
          }
        }
        let checkThree=this.checkSql(this.search_form.relationThree,this.search_form.fieldThree,this.search_form.conditionThree,this.search_form.conditionValueThree)
        if(checkThree[0]){
          if(checkThree[1]){
            this.queryWapper+=this.connectSql(this.search_form.relationThree,this.search_form.fieldThree,this.search_form.conditionThree,this.search_form.conditionValueThree,this.search_form.suffixThree)
          }else{
            this.$message.warning('条件3存在不完整查询！请填写完整')
            return false
          }
        }
        let checkFour=this.checkSql(this.search_form.relationFour,this.search_form.fieldFour,this.search_form.conditionFour,this.search_form.conditionValueFour)
        if(checkFour[0]){
          if(checkFour[1]){
            this.queryWapper+=this.connectSql(this.search_form.relationFour,this.search_form.fieldFour,this.search_form.conditionFour,this.search_form.conditionValueFour,this.search_form.suffixFour)
          }else{
            this.$message.warning('条件4存在不完整查询！请填写完整')
            return false
          }
        }
        let checkFive=this.checkSql(this.search_form.relationFive,this.search_form.fieldFive,this.search_form.conditionFive,this.search_form.conditionValueFive)
        if(checkFive[0]){
          if(checkFive[1]){
            this.queryWapper+=this.connectSql(this.search_form.relationFive,this.search_form.fieldFive,this.search_form.conditionFive,this.search_form.conditionValueFive,this.search_form.suffixFive)
          }else{
            this.$message.warning('条件4存在不完整查询！请填写完整')
            return false
          }
        }
        this.showFields=''
        this.new_field_list.forEach(item=>{
          this.showFields+=item+','
        })
        this.query_current_page=1
        this.query_page_size=1000
        this.activeName='two'
        //获取查询列表
        this.get_query()
      },
      //重置查询表单
      reset_query(){
        this.$refs.search_form.resetFields()
        this.field_list=[]
        this.show_field_list=[]
        this.new_field_list=[]
        this.query_current_page=1
        this.query_page_size=1000
      },
      //查询列表分页
      query_current_change(val){
        this.query_current_page=val
        //获取查询列表
        this.get_query()
      },
      query_size_change(val){
        this.query_page_size=val
        //获取查询列表
        this.get_query()
      },
      //是否可以导出数据
      doExport(){
        let that=this
        that.$axios({
          method:'get',
          url:that.publicAjax.extra_path+'/middle/custom_function/canExport/'+that.search_form.functionName
        }).then(data=>{
          if(data.data.success==true){
            if(data.data.data=='Y'){
              if(that.query_total==0){
                that.$message.warning('无数据导出！')
              }else if(that.query_total>60000){
                that.$message.warning('报表数据超过6W,请添加查询条件筛选数据再导出！')
              }else{
                that.exportExcel()
              }
            }else{
              that.$message.warning("当前报表暂未开放导出功能,请联系管理员！！")
            }
          }else{
            that.$message.warning(data.data.message)
          }
        })
      },
      //导出Excel
      exportExcel(){
        const loading=this.$loading({
          lock:true,
          text:'正在拼命导出，请稍候...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.3)'
        })
        let that=this
        let url='/middle/custom_function/export/'+that.search_form.functionName+'?showFields='+that.showFields+'&queryWrapper='+that.queryWapper
        url=encodeURI(url)
        let xmlResquest=new XMLHttpRequest()
        xmlResquest.open('GET',this.publicAjax.extra_path+url,true)
        //设置请求头类型
        xmlResquest.setRequestHeader("Content-type", "application/json")
        xmlResquest.setRequestHeader("scctoken",localStorage.getItem(localStorage.getItem('userName')+'token'))
        xmlResquest.responseType="blob"
        xmlResquest.onreadystatechange=function(){
          if(xmlResquest.status===200){
            if(xmlResquest.readyState===4){
              var content=xmlResquest.response
              if(content.size==104){
                that.$message.warning('暂未授权，无权操作,请联系管理员！')
              }else{
                var elink=document.createElement('a')
                elink.download=that.$refs.function_name.selected.label+".xls"
                elink.style.display='none'
                var blob=new Blob([content])
                elink.href=URL.createObjectURL(blob)
                document.body.appendChild(elink)
                elink.click()
                document.body.removeChild(elink)
                loading.close()
              }
            }
          }else{
            loading.close()
          }
        }
        xmlResquest.send()
        return false
      }
    }
  }
</script>

<style scoped="scoped">
  .search_form .el-form-item{
    width: 19%;
    display: inline-block;
  }
  .search_form .form_other{
    width: 49%;
  }
  .search_form .form_other1{
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/report/query.vue